const VISIBLE_DIGITS = 4
const MASKING_CHARACTER = '*'

export const ROUTE_PREFIX = '^(settings\\.subscription|subscription-mobile|)\\.?'

export function maskCreditCardNumber (number = '') {
  const maskLength = number.length >= VISIBLE_DIGITS ? number.length - VISIBLE_DIGITS : 0
  const maskingRegex = new RegExp(`.{${maskLength}}`)
  const separatingRegex = /.{1,4}(?=(.{4})+$)/g

  return number
    .replace(maskingRegex, MASKING_CHARACTER.repeat(maskLength))
    .replace(separatingRegex, '$& ')
}

export function routesMatch (route, routeName = '') {
  const NOT_FOUND = -1
  const REGEX_ROUTE = new RegExp(`${ROUTE_PREFIX}${route}$`)

  return routeName
    ? routeName?.search(REGEX_ROUTE) > NOT_FOUND
    : false
}

export function includesRoute (routes, routeName) {
  const found = routes.find(route =>
    routesMatch(route, routeName)
  )
  return found !== undefined
}

export function getPrefix (mobile = false) {
  return mobile
    ? 'subscription-mobile'
    : 'settings.subscription'
}

export function getFullRouteName (routeName, mobile = false) {
  const prefix = getPrefix(mobile)
  return `${prefix}${routeName ? '.' : ''}${routeName || ''}`
}
